import React, { useEffect, useState } from 'react';

function CustomImage({ src, alt, style, className, fallbackText }) {
    const [isWhiteLogo, setIsWhiteLogo] = useState(false);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setIsWhiteLogo(false);
        setHasError(false);
        
        if (!src || (typeof src === 'string' && src.includes('cross'))) {
            setHasError(true);
            return;
        }

        const image = new Image();
        image.crossOrigin = "Anonymous";
        image.src = src;
        
        image.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0);

            try {
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const data = imageData.data;
                let whitePixels = 0;
                let totalVisiblePixels = 0;

                for (let i = 0; i < data.length; i += 4) {
                    const alpha = data[i + 3];
                    if (alpha > 10) { 
                        totalVisiblePixels++;
                        const r = data[i];
                        const g = data[i + 1];
                        const b = data[i + 2];
                        
                        if (r > 240 && g > 240 && b > 240) {
                            whitePixels++;
                        }
                    }
                }

                if (totalVisiblePixels > 0 && (whitePixels / totalVisiblePixels) > 0.90) {
                    setIsWhiteLogo(true);
                }
            } catch (e) {
            }
        };

        image.onerror = () => {
            setHasError(true);
        };
    }, [src]);

    if (hasError && fallbackText) {
        const letter = fallbackText.charAt(0).toUpperCase();
        const colors = ['#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899', '#14b8a6', '#f97316', '#6366f1'];
        const colorIndex = letter.charCodeAt(0) % colors.length;
        const backgroundColor = colors[colorIndex];

        return (
            <div 
                className={className}
                style={{
                    ...style, 
                    backgroundColor, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    color: 'white',
                    fontFamily: 'Gabarito-Bold, sans-serif',
                    borderRadius: '50%',
                    fontSize: style?.width ? `calc(${style.width} * 0.5)` : '12px'
                }}
            >
                {letter}
            </div>
        );
    } else if (hasError) {
        return (
            <div 
                className={className}
                style={{
                    ...style, 
                    backgroundColor: '#e2e8f0', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    borderRadius: '50%'
                }}
            >
                <span style={{color: '#94a3b8', fontSize: '10px', fontFamily: 'Gabarito-Bold'}}>?</span>
            </div>
        );
    }

    const combinedStyle = { 
        ...style, 
        mixBlendMode: 'multiply',
        ...(isWhiteLogo ? { filter: 'brightness(0)' } : {}) 
    };

    return <img src={src} alt={alt} style={combinedStyle} className={className} onError={() => setHasError(true)} />;
}

export default CustomImage;